/**
 * FILE-OVERVIEW:
 * - 役割: カテゴリ・エリア・ボタン配色の定義ファイル。
 * - 主な連携: CalendarMain.js, FilterSidebar.js, MemoFilterSidebar.js
 * - 本番運用上の注意: 色キー名変更は参照側のマップ不一致を起こすため注意。
 */

import { createTheme } from '@mui/material/styles';

// テーマ設定
export const theme = createTheme({
  palette: {
    primary: { main: '#2196f3' },
    secondary: { main: '#f50057' },
    background: { paper: '#ffffff', default: '#ffffff' },
    mono: { main: '#333333' },
    switch: { on: '#333333', off: '#bdbdbd' },
  },
});

// カテゴリごとの色設定
export const categoryColors = {
  社会: '#ffb699', // サーモン
  政治: '#afeeee', // ラベンダー
  経済: '#f0e68c', // カーキ
  地域: '#98fb98', // ライトグリーン
  運動: '#40e0d0', // ターコイズ
  文化: '#ffc0cb', // ピンク
  天鐘: '#cdaef8', // さらに淡いバイオレット（白文字可読）
  プライベート: '#d9d9d9', // グレー
  後日掲載: '#FFFFFF', // 白（固定）
};

// カテゴリごとの枠線色設定
export const categoryBorderColors = {
  社会: '#fa8072', // 濃いサーモン
  政治: '#00bfff', // 濃いラベンダー
  経済: '#daa520', // 濃いカーキ
  地域: '#66bb6a', // 濃いライトグリーン
  運動: '#20b2aa', // 濃いターコイズ
  文化: '#ff69b4', // 濃いピンク
  プライベート: '#212121', // ダークグレー
  後日掲載: '#000000', // 黒（固定）
  天鐘: '#a36ef0', // やや淡いバイオレットの枠線色
};

// エリアごとの色設定
export const areaColors = {
  本社: '#fbe983',
  青森: '#9fe1e7',
  総支局: '#92e1c0',
};

// スケジュール表示（イベントカード）共通カラー
export const scheduleEventColors = {
  background: '#f5f5f5',
  border: '#212121',
  text: '#000000',
  privateBackground: '#e1e1e1',
  privateBorder: '#d50000',
  privateText: '#d50000',
};

// スケジュール画面サイドバーのフィルターボタン共通カラー
// 注: 既存命名は selected* が OFF 状態を指す（やや紛らわしい）。値のみ更新して視認性を改善。
//   ON（選択中） : ダークシアン(#00838f) ＋ 白文字
//   OFF（未選択）: サイドバー同色(#f5f5f5) ＋ うすグレー文字
//   ホバー       : さらに濃いシアン(#006064) で押下感を出す（ON/OFF 共通）

export const scheduleFilterButtonColors = {
  background: '#00838f',          // ON 時の背景
  border: '#00838f',
  text: '#ffffff',                // ON 時の文字
  selectedBackground: '#f5f5f5',  // OFF 時の背景（サイドバーと同色）
  selectedText: '#9e9e9e',        // OFF 時の文字
  hoverBackground: '#006064',
  hoverBorder: '#006064',
  unselectedText: '#9e9e9e',
};

// メディア状態ごとの色設定
export const mediaStatusColors = {
  未派生: '#2196f3', // 青
  派生済: '#00897b', // ティール
};

// 掲載状態ごとの色設定
export const publishingStatusColors = {
  未掲載: '#e65100', // オレンジ
  掲載済み: '#4caf50', // グリーン
  降版済み: '#9e9e9e', // グレー
  出稿済み: '#ff9800', // アンバー
};

// 資料指定バッジカラー
export const badgeColors = {
  newsGenre: '#404048',       // 灰 - テーマ種別バッジ
  publishingStatus: '#a1a3a6', // 黒 - 掲載状態バッジ
  mediaStatus: '#cbe5cd',     // 緑 - 派生状態バッジ
  publishingInfo: '#6994c7',  // 青 - 掲載情報バッジ
};
